import React from 'react'
import NotificationSuccess from '../components/Checkout/NotificationSuccess'
import Container from '../components/misc/Container'
import LayoutHomepage from '../layout/LayoutHomepage'

const CheckoutSuccess = () => {
  return (
    <LayoutHomepage>
      <Container>
        <div className="flex items-center justify-center h-80 w-full my-12 bg-white rounded mt-40">
         <NotificationSuccess/>
        </div>
      </Container>
    </LayoutHomepage>
  )
}

export default CheckoutSuccess